import gql from 'graphql-tag';

export const fetchGuestFace = gql`
  query fetchGuestFace($guestId: Int!) {
    fetchGuestFace(guestId: $guestId) {
      base64Photo
      contentType
    }
  }
`;
